import { render, staticRenderFns } from "./SviluppatoreSistemista.vue?vue&type=template&id=f4241a9e&"
import script from "./SviluppatoreSistemista.vue?vue&type=script&lang=js&"
export * from "./SviluppatoreSistemista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports